var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgArrowRight({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 5.79307C0.89543 5.79307 -3.82585e-07 6.65762 -3.37633e-07 7.7241C-2.9268e-07 8.79059 0.895429 9.65514 2 9.65514L13.1716 9.65514L10.5858 12.1518C9.80474 12.9059 9.80474 14.1285 10.5858 14.8827C11.3668 15.6368 12.6332 15.6368 13.4142 14.8827L19.4142 9.08955C19.7893 8.72741 20 8.23625 20 7.72411C20 7.21196 19.7893 6.72079 19.4142 6.35866L13.4142 0.565552C12.6332 -0.188563 11.3668 -0.188563 10.5858 0.565552C9.80474 1.31967 9.80474 2.54233 10.5858 3.29645L13.1716 5.79307L2 5.79307Z",
    fill: "url(#paint0_linear)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear",
    x1: -3.37633e-7,
    y1: 7.7241,
    x2: 20,
    y2: 7.7241,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#59B9AE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3D92A9"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRight);
export default __webpack_public_path__ + "static/media/arrow-right.5ee5ddb2.svg";
export { ForwardRef as ReactComponent };